import RelationshipMetadata from "../../RelationshipMetadata";

class ETLJobETLJobExecutionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ETLJobETLJobExecution";
        this.parentEnterpriseComponent = "ETLJob";
        this.childEnterpriseComponent = "ETLJobExecution";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ETLJobUSID";
    }
}

export default ETLJobETLJobExecutionRelationshipMetadata;